import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Check if environment variables are configured
const isConfigured = supabaseUrl && supabaseAnonKey && 
  !supabaseUrl.includes('placeholder') && 
  !supabaseAnonKey.includes('placeholder') &&
  supabaseUrl !== 'your_supabase_project_url' && 
  supabaseAnonKey !== 'your_supabase_anon_key';

// Create Supabase client
const supabase = createClient<Database>(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: isConfigured,
      persistSession: isConfigured,
      detectSessionInUrl: false,
      flowType: 'pkce'
    }
  }
);

// Log configuration status
if (isConfigured) {
  console.log('✅ Supabase configurado correctamente');
} else {
  console.warn('⚠️ Supabase en modo demo - configura las variables de entorno para producción');
}

// Auth helpers
export const auth = supabase.auth;

// Database helpers
export const db = supabase;

// Storage helpers
export const storage = supabase.storage;

// Real-time helpers
export const realtime = supabase.realtime;

// Test connection function
export const testConnection = async () => {
  try {
    if (!isConfigured) {
      console.log('⚠️ Supabase no configurado - saltando test de conexión');
      return false;
    }
    
    console.log('🔄 Probando conexión a Supabase...');
    const { data, error } = await supabase.from('profiles').select('count').limit(1);
    if (error) {
      console.error('Supabase connection test failed:', error);
      console.error('Error details:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code
      });
      return false;
    }
    console.log('Supabase connection test successful');
    return true;
  } catch (error) {
    console.error('Supabase connection test error:', error);
    
    if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
      console.error('❌ Error de red - verifica tu conexión a internet y la configuración de Supabase');
    }
    
    return false;
  }
};

// Export the supabase client
export { supabase };